import React, { useEffect, useState } from "react";

import ReactDOM from "react-dom";
import { DateRangePicker } from "rsuite";
import "./styles.css";

import Layout from "../../../components/Layout";
import BlackWhiteButton from "../../../components/buttons/BlackWhiteButton";
import {
  List,
  ListHeader,
  ListHeaderItem,
  ListHeaderItemDropdown,
  ListBody,
  ListBodyCell,
  ListBodyItem,
  ListBodyItemAction,
  ListHeaderItemDateRage,
  ListHeaderItemDropdownDateRage,
} from "../../../components/_widgets/WidgetsList";
import api from "../../../config/api";
import { formatDate, getClientAll } from "../../../config/utils";
import { Spinner } from "react-bootstrap";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
require("dotenv").config();

function Client() {
  const history = useHistory();
  const [clientAll, setClientAll] = useState([]);
  const [dateInput, setDateInput] = useState([]);

  // Filters
  const [clientNameAll, setClientNameAll] = useState([]);
  const [filterDropdownEmail, setFilterDropdownEmail] = useState("");
  const [filterDropdownPhone, setFilterDropdownPhone] = useState("");
  const [filterDropdownName, setFilterDropdownName] = useState("");
  const [inputName, setInputName] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");
  const [selectedPhone, setSelectedPhone] = useState("");

  const [loading, setLoading] = useState(true);

  // Pagination
  const [qtLimitItem, setQtLimitItem] = useState(10);
  const [pageItemsList, setPageItemsList] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    getClient(pageItemsList, qtLimitItem, selectedName, selectedEmail, selectedPhone, inputName, dateInput);
    getAll();
  }, []);

  const getClient = async (page, qtLimitItem, selectedName, selectedEmail, selectedPhone, inputName, dateInput) => {
    try {
      let startDateFormat = [];
      let endDateFormat = [];

      if (dateInput?.length > 0) {
        startDateFormat = new Date(dateInput[0]).toISOString();
        endDateFormat = new Date(dateInput[1]).toISOString();
      }

      const response = await api.get(
        `/user?role=client&paginate=true&limit=${qtLimitItem}&page=${page}&email=${selectedEmail}&name=${
          inputName ? inputName : selectedName
        }&phone=${selectedPhone}&startDate=${startDateFormat}&endDate=${endDateFormat}&status=active`
      );
      const { docs = [] } = response.data;

      setClientAll(docs);
      setTotalItems(response.data.total);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteUser = async (id) => {
    await api
      .delete(`/user/${id}`)
      .then((resp) => {
        setPageItemsList(1);
        getClient(1, qtLimitItem, selectedName, selectedEmail, selectedPhone, inputName, dateInput);
        swal("Sucesso!", "Usuário excluído com sucesso", "success");
      })
      .catch((error) => {
        swal("Erro!", "Erro ao excluir usuário", "error");
        console.log(error.message);
      });
  };

  // Pagination
  const setLimitList = (value) => {
    setQtLimitItem(value);
    getClient(pageItemsList, value, selectedName, selectedEmail, selectedPhone, inputName);
  };

  const changePage = (event) => {
    setPageItemsList(Number(event.target.id));
    getClient(event.target.id, qtLimitItem, selectedName, selectedEmail, selectedPhone, inputName, dateInput);
  };

  const prevButton = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
      getClient(pageItemsList - 1, qtLimitItem, selectedName, selectedEmail, selectedPhone, inputName, dateInput);
    }
  };

  const nextButton = () => {
    let qtPages = Math.ceil(totalItems / qtLimitItem);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(pageItemsList + 1);
      getClient(pageItemsList + 1, qtLimitItem, selectedName, selectedEmail, selectedPhone, inputName, dateInput);
    }
  };

  // Filter
  const getAll = async () => {
    try {
      const res = await getClientAll();
      // console.log("res", res.list);
      setTotalItems(res.total);
      setClientNameAll(res.list);
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleSelectclientAll = (value) => {
    setSelectedName(value);
    setPageItemsList(1);
    getClient(1, qtLimitItem, value, selectedEmail, selectedPhone, inputName, dateInput);
  };

  const handleSelectEmailAll = (value) => {
    setSelectedEmail(value);
    setPageItemsList(1);
    getClient(1, qtLimitItem, selectedName, value, selectedPhone, inputName, dateInput);
  };

  const handleSelectedPhoneAll = (value) => {
    setSelectedPhone(value);
    setPageItemsList(1);
    getClient(1, qtLimitItem, selectedName, selectedEmail, value, inputName, dateInput);
  };
  const handleInputNameFilter = (value) => {
    setInputName(value);
    setPageItemsList(1);
    getClient(1, qtLimitItem, selectedName, selectedEmail, selectedPhone, value, dateInput);
  };
  const handleInputDate = (value) => {
    setDateInput(value);
    setPageItemsList(1);
    getClient(1, qtLimitItem, selectedName, selectedEmail, selectedPhone, inputName, value);
  };

  const exportTable = async () => {
    await api
      .get(`/clients-excel`, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Layout defaultMenu={4} title={"Clientes"} link={""}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="d-flex flex-column flex-lg-row">
            <div className="col-12 col-lg-3 mt-2">
              <div className="input-group input-search mb-3">
                <input
                  value={inputName}
                  onChange={({ target }) => handleInputNameFilter(target.value)}
                  type="text"
                  className="form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto"
                  placeholder="Buscar"
                />
                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search text-cl-auroMetal"></i>
                </span>
              </div>
            </div>
            <BlackWhiteButton
              onClick={() => exportTable()}
              className="mb-3 py-2"
              size={12}
              sizeLg={9}
              text="Exportar planilha"
            />
          </div>
          <div className="d-flex flex-column flex-lg-row pb-4">
            <List
              section={"clientes"}
              onChange={(e) => setLimitList(e.target.value)}
              limit={qtLimitItem}
              totalItem={totalItems}
              prevButton={() => prevButton()}
              nextButton={() => nextButton()}
              page={pageItemsList}
              changePage={(e) => changePage(e)}
            >
              <ListHeader>
                {/* Filtros por nome */}
                <ListHeaderItem sizeLg={3} title={"Nome"} filter={selectedName}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          value={filterDropdownName}
                          onChange={(e) => setFilterDropdownName(e.target.value)}
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por estabelecimento"}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div key={"all"} onClick={() => handleSelectclientAll("")} className="dropdown-item">
                        <span>Todos</span>
                      </div>
                      {clientNameAll
                        .filter(
                          (element) =>
                            filterDropdownName === "" ||
                            String(element.name).toLowerCase().includes(filterDropdownName.toLocaleLowerCase())
                        )
                        .map((item, index) => (
                          <div
                            key={index}
                            onClick={() => handleSelectclientAll(item.name)}
                            className="dropdown-item"
                            style={selectedName === item._id ? { backgroundColor: "#0d80ff", color: "white" } : {}}
                          >
                            <span>{item.name}</span>
                          </div>
                        ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>

                {/* Filtros por Email */}

                <ListHeaderItem sizeLg={3} title={"Email"} filter={selectedEmail}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          value={filterDropdownEmail}
                          onChange={(e) => setFilterDropdownEmail(e.target.value)}
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por estabelecimento"}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div key={"all"} onClick={() => handleSelectEmailAll("")} className="dropdown-item">
                        <span>Todos</span>
                      </div>

                      {clientNameAll
                        .filter(
                          (element) =>
                            filterDropdownEmail === "" ||
                            //Falta botar o storeEmail

                            String(element.email).toLowerCase().includes(filterDropdownEmail.toLocaleLowerCase())
                        )
                        .map((item, index) => (
                          <div
                            key={index}
                            onClick={() => handleSelectEmailAll(item.email)}
                            className="dropdown-item"
                            style={selectedEmail === item.email ? { backgroundColor: "#0d80ff", color: "white" } : {}}
                          >
                            <span>{item.email}</span>
                          </div>
                        ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>

                <ListHeaderItem sizeLg={3} title={"Telefone"} filter={selectedPhone}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          value={filterDropdownPhone}
                          onChange={(e) => setFilterDropdownPhone(e.target.value)}
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por estabelecimento"}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div key={"all"} onClick={() => handleSelectedPhoneAll("")} className="dropdown-item">
                        <span>Todos</span>
                      </div>

                      {clientNameAll
                        .filter(
                          (element) =>
                            filterDropdownPhone === "" ||
                            //Falta botar o storeEmail

                            String(element.phone).toLowerCase().includes(filterDropdownPhone.toLocaleLowerCase())
                        )
                        .map((item, index) => (
                          <div
                            key={index}
                            onClick={() => handleSelectedPhoneAll(item.phone)}
                            className="dropdown-item"
                            style={selectedPhone === item.phone ? { backgroundColor: "#0d80ff", color: "white" } : {}}
                          >
                            <span>{item.phone}</span>
                          </div>
                        ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>

                <ListHeaderItemDateRage sizeLg={3} title={"Data de registro"}>
                  <ListHeaderItemDropdownDateRage>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{
                        borderBottom: "1px solid #D9D9D9",
                      }}
                    >
                      <div className="dates">
                        <DateRangePicker placeholder="Insira a data desejada" onChange={(e) => handleInputDate(e)} />
                      </div>
                    </li>
                  </ListHeaderItemDropdownDateRage>
                </ListHeaderItemDateRage>
              </ListHeader>
              <ListBody>
                {loading ? (
                  <>
                    <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ height: "8rem", width: "8rem", borderWidth: "0.8em" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  </>
                ) : (
                  <>
                    {clientAll.length ? (
                      <>
                        {clientAll.map((item, index) => (
                          <ListBodyCell key={index} className={`${index % 2 !== 0 ? "bg-cl-cultured" : ""} c-pointer`}>
                            <ListBodyItem
                              sizeLg={3}
                              description={"Nome"}
                              title={item.name}
                              onClick={() => history.push(`/cliente/${item._id}`)}
                            />
                            <ListBodyItem
                              sizeLg={3}
                              description="Email"
                              title={item.email}
                              onClick={() => history.push(`/cliente/${item._id}`)}
                            />
                            <ListBodyItem
                              sizeLg={3}
                              description={"Telefone"}
                              title={item.phone}
                              onClick={() => history.push(`/cliente/${item._id}`)}
                            />

                            <ListBodyItem
                              sizeLg={2}
                              description={"Data de registro"}
                              title={formatDate(item.createdAt)}
                              onClick={() => history.push(`/cliente/${item._id}`)}
                            />

                            <ListBodyItemAction sizeLg={1} title={"edit"}>
                              <li>
                                <span
                                  className="dropdown-item fz-14 ff-univanova-regular c-pointer text-decoration-underline text-cl-azure"
                                  data-bs-toggle="modal"
                                  data-bs-target="#myModalSingle"
                                >
                                  Editar
                                </span>
                              </li>
                              <li>
                                <span
                                  className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer text-decoration-underline text-cl-red"
                                  onClick={() => deleteUser(item._id)}
                                >
                                  Excluir
                                </span>
                              </li>
                            </ListBodyItemAction>
                          </ListBodyCell>
                        ))}
                      </>
                    ) : (
                      <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
                        <span> Nenhum cliente cadastrado</span>
                      </div>
                    )}
                  </>
                )}
              </ListBody>
            </List>
          </div>
        </div>
      </Layout>
    </>
  );
}
ReactDOM.render(<Client />, document.getElementById("root"));
export default Client;
